// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("css/" + {"335":"e97313d3169ec7d2c052","506":"e97313d3169ec7d2c052"}[chunkId] + ".css");